<template>
  <div class="container">
    <form v-model="loginForm" style="margin-left: 50%;margin-top: 15%;">
      <div class="logoImg">
        <img src="../assets/logo_y.gif" width="200px" >
      </div>
      <div style="display: flex;flex-wrap: wrap;">
        <div>
          <img src="../assets/user1.jpg" class="" width="40px">
        </div>
        <input class="input " type="text" name="username" v-model="loginForm.username"  placeholder="用户名" @blur="changeVal"><br>

      </div>

      <div style="display: flex;flex-wrap: wrap;margin-top: 30px;">
        <div>
          <img src="../assets/pwd1.jpg" class="" width="40px">
        </div>
        <input class="input " type="password" name="password" v-model="loginForm.password" placeholder="密码" @blur="changeVal"><br>
      </div>

      <div style="text-align: center;color: black;font-size: 15px;" class="tip">{{tip}}</div>

      <div class="loginBtn">
        <input class="button" type="button" value="登陆" @click="login">
      </div>


    </form>



  </div>
</template>

<script>
  import axios from 'axios';
  import jwt from 'jsonwebtoken';

  export default {
    name: "Login",
    data:function(){
      return{
        loginForm:{
          username:'',
          password:''
        },
        tip:' ',
      }
    },
    mounted() {

    },
    methods:{
      login(){
        axios.post(this.GLOBAL.serverURL+'api/login/',{
          username:this.loginForm.username,
          password:this.loginForm.password
        })
          .then(res=>{
            console.log("then...");
            console.log(res);
            if(res.data.ret=='1000'){
              console.log('登陆成功');
              //     console.log('token:'+ this.GLOBAL.token);
              this.GLOBAL.token =res.data.token;  //将token存入全局变量中

              this.GLOBAL.userId =jwt.decode(res.data.token).id;

              //在IE 浏览器使用window.localStorage会报错
              window.localStorage.setItem('token',res.data.token);   //将token存入浏览器localStorage
              window.localStorage.setItem('username',jwt.decode(res.data.token).username); //将解码后的用户信息存入浏览器localStorage
              window.localStorage.setItem('id',jwt.decode(res.data.token).id); //将解码后的用户信息存入浏览器localStorage
              //
              // console.log('jwt:')
              // console.log(jwt.decode(res.data.token));
              // console.log(window.localStorage.getItem('username'));


              console.log('token:'+ this.GLOBAL.token+' userId: '+this.GLOBAL.userId);
              this.$router.push("/home");  //进入课程页
            }else{
              console.log('登陆失败');
              console.log(res);
              this.tip='用户名或密码错误!';
              // setTimeout("this.tip=false;console.log(this.tip);",3000)
              // window.setInterval("this.tip=false;",3000);
            }
          })
          .catch(res=>{
            console.log("catch...");
            console.log(res);
          })
          .finally(res=>{
            console.log("finally...");
            setTimeout("this.tip=false;console.log(this.tip);",3000)
          });
        // this.$router.push("/course");
      },

      changeVal(){
        this.tip='';
      }


    },
  }

</script>


<style  scoped>


  .container{
    background-image: url("../assets/bg2.jpg");
    background-repeat: no-repeat;
    /*background-attachment: fixed;*/
    background-size:  100%;
    width: 100%;
    height: 100%;
    display: flex;
  }

  .logoImg{
    position: fixed;
    left: 25%;
    top: 31%;
  }

  .userImg{
    position: fixed;
    left: 50%;
    top: 20%;
    z-index: 999;
  }
  .username{
    position: fixed;
    left: 50%;
    top: 20%;
  }

  .pwdImg{
    position: fixed;
    left: 50%;
    top: 35%;
    z-index: 999;
  }
  .password{
    position: fixed;
    left: 50%;
    top: 35%;
  }
  .loginBtn{
    margin-top: 50px;
  }

  .tip{
    margin-top: 20px;
  }
  .input{

    outline: 0;
    border: 1px solid rgba(255, 255, 255, 0.8);
    background-color: rgba(255, 255, 255, 0.7);
    width: 250px;
    border-radius: 3px;
    padding: 10px 15px;
    margin: 0 auto 10px auto;
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 300;
  }
  .button{

    outline: 0;
    border: 1px solid rgba(85, 85, 87, 0.5);
    background-color: rgba(255, 255, 255, 0.3);
    width: 100px;
    border-radius: 10px;
    padding: 10px 15px;
    margin: 0 auto 10px auto;
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 300;
  }


</style>



// WEBPACK FOOTER //
// src/views/Login2.vue